import {TableConfig, TableMark} from "@/link-components/table/utils/TableMark";
import {TableCheckStatus} from "@/link-components/table/utils/NodeUtils";

export class TableNode {
	constructor(
		public id: string,
		public row: any,
		public level: number,
		public isSummaryData: boolean,
		public config: () => TableConfig,
		public parentRef: () => TableNode,
		public markRef: () => TableMark,
	) {}

	index?: number
	selfGetter = () => this;

	// 树形表格：子节点数据
	get childrenData() {return !!this.config().childrenField && !!this.row ? this.row[this.config().childrenField!] as any[] : undefined}

	// 树形表格：子节点对象
	get children() {return !this.childrenData ? undefined : this.childrenData.map(child => this.markRef().node.get(child, this.level + 1, this.selfGetter, this.isSummaryData))}

	/*---------------------------------------mark attrs-------------------------------------------*/

	/*@formatter:off*/
	    // 树形表格：当前是否已经展开
    get isExpand(): boolean {return this.markRef().expand.get(this.id)}
    // 树形表格：当前是否选中
    get isCheck(): boolean {return this.markRef().check.get(this.id)}
    // 树形表格：当前是否正在加载子节点数据
    get isLoading(): boolean {return this.markRef().loading.get(this.id)}
    // 树形表格：当前子节点数据是否已经加载完毕
    get isLoaded(): boolean {return this.markRef().loaded.get(this.id)}
    // 树形表格：当前行是否可选中
    get isCheckable(): boolean {return !this.config().isCheckable || this.config().isCheckable!(this)}
    // 树形表格：当前行是否为叶子节点
    get isLeaf(): boolean {return !!this.config().isLeaf ? this.config().isLeaf!(this) : (!this.children || this.children.length === 0)}
    // 树形表格：当前行是否可见
    get isVisible(): boolean {
        const {filterNodeMethod} = this.config()
        if (!filterNodeMethod) {
            return true
        }
        let visible = filterNodeMethod(this)
        if (visible) {
            return true
        } else {
            return (this.children || []).some(child => child.isVisible)
        }
    }
    // 树形表格：当前选中状态：选中、未选中、半选中
    get checkStatus(): TableCheckStatus {

        if (this.isLeaf || this.config().checkStrictly) {
            // 叶子节点或者父子互不关联情况下，节点只有选中以及非选中的状态，不会处于半选中状态
            return this.isCheck ? TableCheckStatus.check : TableCheckStatus.uncheck
        } else {
            // 当前已经选中，则处于选中状态
            if (this.isCheck) return TableCheckStatus.check

            // 当前未选中，判断子节点是否全部都是未选中状态，是则自身为未选中状态，否则为半选中状态
            if ((this.children || []).every(child => child.checkStatus === 'uncheck')) {
                return TableCheckStatus.uncheck
            } else {
                return TableCheckStatus.minus
            }
        }
    }

    // 当前行编辑数据对象
	get editRow(): object {return this.markRef().editRow.get(this.id)}
	set editRow(val: object) {this.markRef().editRow.set(this.id, val)}
	/*@formatter:on*/

	/*---------------------------------------methods-------------------------------------------*/

	loading(val: boolean) {
		this.markRef().loading.set(this.id, val)
	}

	loaded(val: boolean) {
		this.markRef().loaded.set(this.id, val)
	}

	/**
	 * 选中/取消选中 当前节点
	 * @author  韦胜健
	 * @date    2020/4/1 22:37
	 */
	check(val: boolean) {
		if (!this.isCheckable) return
		this.markRef().check.set(this.id, val)
	}

	/**
	 * 展开/收起当前节点
	 * @author  韦胜健
	 * @date    2020/5/12 9:47
	 */
	expand(val: boolean) {
		if (this.isLeaf) return
		this.markRef().expand.set(this.id, val)
	}

	/**
	 * 设置子节点数据
	 * @author  韦胜健
	 * @date    2020/4/3 0:09
	 */
	setChildren(children: object[]) {
		window.Vue.prototype.$set(this.row, this.config().childrenField!, children)
	}

	/**
	 * 获取子节点数据
	 * @author  韦胜健
	 * @date    2020/8/6 20:54
	 */
	getReactiveChildrenData(): object[] {
		let childrenData = this.childrenData
		if (!childrenData) {
			childrenData = []
			this.setChildren(childrenData)
		}
		return childrenData
	}
}